import PropTypes from 'prop-types'
import {
  branch,
  compose,
  withContext,
  renderNothing,
  withProps,
} from 'recompose'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { selectCurrentCELs } from '../../../store/selectors/home/loans'

/**
 * InterestSectionContainer
 * This file sets context for all of its child component, such that the
 * value passed to it for `withCurrentHomeData` is also passed to its context
 *
 * The current pattern is to branch containers dependent on it so they
 * can reliably either access real home state or mock data
 *
 * At time of writing, most containers will have both:
 * * composeWithHomedata
 * * composeWithoutHomeData
 *
 * These branched HoCs are in charge of the data/behavior differences in each
 * component, based on whether or not the withCurrentHomeData flag is present
 */

// If no loans AND real data is being used, prevent render
const composeWithHomeData = compose(
  connect(state => ({
    loans: selectCurrentCELs(state),
  })),
  branch(({ loans }) => !loans.length, renderNothing)
)

// Case withCurrentHomeData to false if undefined
// Implementation to solve for HoC behavior
const defaultProps = withProps(props => ({
  withCurrentHomeData: get(props, 'withCurrentHomeData', false),
}))

// Set prop withCurrentHomeData as context to all children
const provideWithCurrentHomeDataProp = withContext(
  { withCurrentHomeData: PropTypes.bool, locked: PropTypes.bool },
  ({ withCurrentHomeData }) => ({ withCurrentHomeData, locked: false })
)

const InterestSectionContainer = compose(
  defaultProps,
  provideWithCurrentHomeDataProp,
  branch(
    // If using real data, apply additional hoc
    ({ withCurrentHomeData: value }) => value,
    composeWithHomeData
  )
)

export default InterestSectionContainer
